/* src/app/shared-module/components/reschedule-activity/reschedule-activity.component.scss */
.reschedule-modal-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px 16px;
  background:
    linear-gradient(
      145deg,
      var(--ion-color-secondary-shade) 0%,
      #2d4f96 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.reschedule-header-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.22);
  flex-shrink: 0;
}
.reschedule-header-icon-box ion-icon {
  font-size: 22px;
  color: #fff;
}
.reschedule-header-copy {
  flex: 1;
  min-width: 0;
}
.reschedule-header-kicker {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
}
.reschedule-header-title {
  margin: 3px 0 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reschedule-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s ease;
}
.reschedule-close-btn ion-icon {
  font-size: 22px;
  color: #fff;
}
.reschedule-close-btn:hover,
.reschedule-close-btn:focus {
  background: rgba(255, 255, 255, 0.26);
  outline: none;
}
.reschedule-modal-body {
  padding: 16px;
  background:
    linear-gradient(
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.info-card {
  margin: 0 0 16px;
  border-radius: 18px;
  border: 1px solid var(--ion-color-light-tint);
  background: var(--ion-color-secondary);
  box-shadow: 0 6px 16px var(--ion-color-secondary-contrast);
}
.info-card ion-card-content {
  padding: 14px 16px !important;
}
.info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.info-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
  flex-shrink: 0;
}
.info-icon-box ion-icon {
  font-size: 18px;
  color: var(--ion-color-secondary-shade);
}
.info-text {
  font-size: 13px;
  color: var(--ion-color-primary-contrast);
  line-height: 1.55;
}
.info-text strong {
  color: var(--ion-color-secondary-shade);
  font-weight: 700;
}
.section-label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-shade);
  margin-bottom: 12px;
}
.section-label ion-icon {
  font-size: 16px;
  color: var(--ion-color-primary);
}
.status-cards-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}
.status-card {
  margin: 0;
  border-radius: 20px;
  border: 1.5px solid var(--ion-color-light-tint);
  background:
    linear-gradient(
      165deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
  box-shadow: 0 8px 18px var(--ion-color-secondary-contrast);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.status-card ion-card-content {
  padding: 16px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.status-card:hover,
.status-card:focus {
  transform: translateY(-2px);
  box-shadow: 0 12px 22px var(--ion-color-light-tint);
}
.status-card--selected {
  border-color: var(--ion-color-secondary-shade);
  box-shadow: 0 10px 24px var(--ion-color-secondary-contrast);
}
.status-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.status-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  border: 1px solid var(--ion-color-light-tint);
}
.status-icon-box ion-icon {
  font-size: 24px;
}
.status-icon-box--done {
  background: #e8f8f0;
}
.status-icon-box--done ion-icon {
  color: #1e8a4a;
}
.status-icon-box--cancel {
  background: #fdecea;
}
.status-icon-box--cancel ion-icon {
  color: #c0392b;
}
.status-radio {
  --color: var(--ion-color-light-tint);
  --color-checked: var(--ion-color-secondary-shade);
  pointer-events: none;
}
.status-card-title {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  line-height: normal;
}
.status-card-caption {
  display: block;
  font-size: 12px;
  color: var(--ion-color-primary-contrast);
  line-height: 1.45;
}
.reschedule-footer {
  padding-top: 4px;
}
.btn-submit {
  --background: var(--ion-color-secondary-shade);
  --color: #fff;
  --box-shadow: 0 6px 16px var(--ion-color-secondary-contrast);
  --border-radius: 14px;
}
/*# sourceMappingURL=reschedule-activity.component.css.map */
